import React from 'react';
import GenericSection from '../components/sections/GenericSection';
import SectionHeader from '../components/sections/partials/SectionHeader';
import Image from '../components/elements/Image';
import Button from '../components/elements/Button';

class ScriptoresSandbox extends React.Component {

  render() {

    const sectionHeader = {
      title: 'Scriptores Sandbox',
      paragraph: "Experience Scriptores in action. Our sandbox environment lets you explore the platform's capabilities and see how it can transform your oxygen device business operations."
    };

    return (
      <React.Fragment>
        <GenericSection topOuterDivider>
          <div className="container">
            <SectionHeader data={sectionHeader} className="center-content" />
            
            <div className="split-wrap" style={{ marginTop: '48px', alignItems: 'center' }}>
              <div className="split-item">
                <div className="split-item-content center-content-mobile" style={{ paddingRight: '32px' }}>
                  <h3 className="mt-0 mb-16">Custom-Tailored Solution for Oxygen Device Companies</h3>
                  <p className="mb-24">
                    Scriptores is a specialized web application designed exclusively for oxygen device companies operating in Greece. Unlike generic business management software, Scriptores is custom-tailored to meet the unique needs and workflows of medical oxygen providers, ensuring seamless integration with your daily operations.
                  </p>

                  <h4 className="mt-0 mb-12">Automated Prescription Execution</h4>
                  <p className="mb-24">
                    One of Scriptores' core capabilities is the automation of prescription executions. The system processes medical prescriptions efficiently, reducing manual work and minimizing errors. With over 1000 prescriptions executed daily across our client base, Scriptores has proven its reliability and efficiency in handling high-volume prescription processing. The platform automatically validates prescriptions, assigns equipment, schedules deliveries, and manages the entire workflow from prescription receipt to patient service completion.
                  </p>

                  <h4 className="mt-0 mb-12">Direct EOPPY Integration</h4>
                  <p className="mb-24">
                    Scriptores features direct communication with EOPPY (Εθνικός Οργανισμός Παροχής Υγείας - National Organization for Healthcare Provision), the Greek national health system. This integration enables real-time data exchange, automatic verification of patient eligibility, seamless billing processes, and direct submission of claims. By connecting directly with EOPPY, Scriptores eliminates the need for manual data entry and reduces administrative overhead, ensuring compliance with Greek healthcare regulations while streamlining your operations.
                  </p>

                  <div style={{ 
                    backgroundColor: 'var(--color-bg)', 
                    padding: '24px', 
                    borderRadius: '12px',
                    border: '1px solid var(--color-border)',
                    marginBottom: '24px'
                  }}>
                    <h4 className="mt-0 mb-12">Key Benefits:</h4>
                    <ul className="list-reset text-sm">
                      <li className="mb-8">✓ Custom-designed for oxygen device company workflows</li>
                      <li className="mb-8">✓ Automated prescription processing and execution</li>
                      <li className="mb-8">✓ Direct EOPPY system integration for seamless healthcare data exchange</li>
                      <li className="mb-8">✓ Real-time patient eligibility verification</li>
                      <li className="mb-8">✓ Automated billing and claims submission</li>
                      <li className="mb-8">✓ Compliance with Greek healthcare regulations</li>
                      <li className="mb-8">✓ Reduced administrative workload and human error</li>
                    </ul>
                  </div>
                </div>
                <div className="split-item-image center-content-mobile" style={{ flexShrink: 0 }}>
                  <div style={{ 
                    borderRadius: '16px', 
                    overflow: 'hidden',
                    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
                  }}>
                    <Image
                      src="/scriptores_sandbox.PNG"
                      alt="Scriptores Sandbox - Web Application Interface"
                      width={800}
                      height={600}
                      style={{ display: 'block', width: '100%', height: 'auto' }} />
                  </div>
                </div>
              </div>
            </div>

            <div className="center-content" style={{ marginTop: '48px' }}>
              <Button tag="a" color="primary" href="/" wideMobile>
                Back to Home
              </Button>
            </div>
          </div>
        </GenericSection>
      </React.Fragment>
    );
  }
}

export default ScriptoresSandbox;
